import { Theme } from "app/core/theme/theme.interface";
import { ThemeTypes } from "./theme-types";

export const THEMES: Theme[] = [
  {
    value: ThemeTypes.NconnectVoiceTheme,
    label: "NFON SIP Trunk",
    assetFolder: "nconnectvoice",
    host: /siptrunk(?!.*dt\-standard)/i,
  },
  {
    value: ThemeTypes.O2SIPTrunkTheme,
    label: "O2-Business-Teams-Telefonie",
    assetFolder: "o2",
    host: /teamstelefonie.o2business/i,
  },
];
